import { Image } from './common';
import { ChannelType } from '@/src/types/common/SalesChannel';
export enum paymentGatewayProvider {
  ADYEN = 'ADYEN',
  ATOME = 'ATOME',
  STRIPE = 'STRIPE',
  QFPAY_WECHAT_MINI = 'QFPAY_WECHAT_MINI',
  QFPAY_WECHAT_HTML5 = 'QFPAY_WECHAT_HTML5',
  QFPAY_ALI_HTML5 = 'QFPAY_ALI_HTML5',
  BANK_TRANSFER = 'BANK_TRANSFER',
  FPS_QR_CODE = 'FPS_QR_CODE',
  WECHAT_PAY = 'WECHAT_PAY',
}

export enum PaymentMethod {
  ATOME = 'ATOME',
  ALI_PAY = 'ALI_PAY',
  ALI_PAY_HK = 'ALI_PAY_HK',
  QFPAY_WECHAT_MINI = 'QFPAY_WECHAT_MINI',
  QFPAY_WECHAT_HTML5 = 'QFPAY_WECHAT_HTML5',
  QFPAY_ALI_HTML5 = 'QFPAY_ALI_HTML5',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  CREDIT_CARD = 'CREDIT_CARD',
  WECHAT_PAY = 'WECHAT_PAY',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export interface StoreGatewayProviderVO {
  uuid: string;
  storeUuid: string;
  gatewayProviderCode: paymentGatewayProvider;
  gatewayProviderIcon: Image;
  name: string;
  remarks: string;
  configFields:
    | StripeConfigFields
    | QFPayConfigFields
    | BankTransferConfigFields
    | AtomeConfigFields
    | AdyenConfigFields;
  enablePaymentDescriptor: boolean;
  staticPrefix: string;
  gatewayProviderName: string;
  dynamicSuffix: DynamicSuffix;
  webHooks: string[];
  amountLimit?: AmountLimitVOAmountLimitVO[];
  salesChannelPaymentMethods?: SalesChannelPaymentMethodVO[];
  supportedCurrencyCodes: string[];
}

export enum DynamicSuffix {
  OrderNumber = 'OrderNumber',
  OrderID = 'OrderID',
  NoSuffix = 'NoSuffix',
}
export interface AmountLimitVOAmountLimitVO {
  currencyCode: string;
  minAmount: number;
  maxAmount: number;
  minReferenceAmount: number;
  maxReferenceAmount: number;
}
export interface StripeConfigFields {
  gatewayProviderCode: string;
  publishableKey: string;
  secreteKey: string;
  signingKey: string;
}

export interface QFPayConfigFields {
  gatewayProviderCode: string;
  qfCode: string;
  qfKey: string;
  qfURL: string;
}
export interface BankTransferConfigFields {
  gatewayProviderCode: string;
  paymentInstruction: string;
}

export interface AtomeConfigFields {
  gatewayProviderCode: string;
  userName: string;
  password: string;
  paymentURI: string;
}

export interface AdyenConfigFields {
  gatewayProviderCode: string;
  merchantAccount: string;
  merchantID?: string;
  apiKey: string;
  clientKey?: string;
  hmacKey?: string;
  urlPrefix?: string;
}
export interface SalesChannelPaymentMethodVO {
  storeGatewayProviderUuid: string;
  paymentMethod: PaymentMethodVO;
  salesChannelSummaries: SalesChannelSummaryVO;
}

export interface PaymentMethodVO {
  uuid: string;
  gatewayProviderCode: paymentGatewayProvider;
  paymentMethodCode: PaymentMethod;
  name: string;
  subName: string;
  icons: Image[];
}

export interface SalesChannelSummaryVO {
  storeUuid: string;
  salesChannelUuid: string;
  salesChannelName: string;
  channelType: ChannelType;
}
